import { useTranslation } from "@/features/utils/i18n";
import { PageLayout } from "../backoffice/layout";
import { SecuritySection } from "./sections/security-section";

export const ProfilePage = () => {
  const { t } = useTranslation("preferences");
  return (
    <PageLayout
      width="narrow"
      title={t("security.title")}
      description={t("security.description")}
    >
      <SecuritySection />
    </PageLayout>
  );
};
